import { defaultGraphSettings, type GraphSettingsType } from "@/types";

/** Saved graph_settings must not straighten recommendation arcs. */
export function mergeGraphSettings(
  base: GraphSettingsType,
  stored: Partial<GraphSettingsType> | null | undefined,
): GraphSettingsType {
  return {
    ...base,
    ...stored,
    curvedEdges: true,
  };
}

/** Map defaults, then a local snapshot. Recommendation arcs stay curved. */
export function mapGraphSettings(
  stored: Partial<GraphSettingsType> | null | undefined,
): GraphSettingsType {
  return mergeGraphSettings(
    {
      ...defaultGraphSettings(),
      doubleClickZoomEnabled: false, // host dblclick recenters
      focusViewEnabled: false,
    },
    stored,
  );
}
